import Vue from "vue";
Vue.mixin({
  methods: {
    boolConfirm(ok, cancel) {
      const opt: object = {
        titleClass: "text-center font-weight-normal text-14",
        hideHeader: true,
        hideHeaderClose: true,
        headerClass: "border-0 pt-4 px-4 pb-0",
        bodyClass: "d-none",
        contentClass: "border-0 shadow py-3",
        footerClass: "border-0 d-block px-3",
        cancelTitle: cancel,
        okTitle: ok,
        cancelVariant: "secondary w-100 text-14 rounded text-center mb-2",
        okVariant: "secondary w-100 text-14 rounded text-center",
        centered: true,
        size: "sm",
        noCloseOnBackdrop: true,
        hideBackdrop: true,
      };
      const msgVNode = this.$createElement("div", {});
      return this.$bvModal.msgBoxConfirm([msgVNode], opt);
    },
  },
});
